import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 26, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.75, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className, as = "span" }) => {
    const LineTag = motion[as] || motion.span;
    return (
        <span className="mask-line">
            <LineTag
                className={className}
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, delay, ease: EASE }}
            >
                {children}
            </LineTag>
        </span>
    );
};

export const FadeIn = ({ children, delay = 0, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.9, delay, ease: "easeOut" }}
    >
        {children}
    </motion.div>
);
